import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import TextSection from '../components/TextSection';
import Banner from '../components/Banner';

const mapStateToProps = state => ({
  user: get(state, 'user'),
});

/**
 * Advertising container
 *
 * @param {object} props
 */
const Advertising = () => {
  return (
    <>
      <Banner title="Advertise with us" imageUrl="/assets/img/spin.jpeg" />
      <TextSection
        textHtml={
          <div
            className="gel-wrap o-slice-spacing-bottom gel-pica"
            style={{ textAlign: 'left' }}
          >
            <p className="gs-u-mb++">
              Are you a local business looking to raise your profile within the
              Moffat community and beyond? We have a great new opportunity at
              the Gym at Moffat for advert placements to help you promote your
              business.
            </p>
            <p className="gs-u-mb++">
              Our gym has around <b>200 members</b> (ages 12 and up) from Moffat
              and the surrounding areas. Additionally, we welcome a range of
              short-term visitors - <b>around 200 PAYG customers</b> - including
              families from various parts of the country. These visitors not
              only use the gym equipment and attend classes but also hire the
              court for badminton, pickleball, and basketball.
            </p>
            <p className="gs-u-mb++">
              On top of this, we have almost <b>50 gymnasts</b> who attend the
              gym, with their parents regularly visiting the gym hall or waiting
              to collect their children. This gives us a{' '}
              <b>visitor frequency of several hundred people every week</b>.
            </p>
            <p className="gel-pica-bold gs-u-mb++">
              Advertising Package Includes:
            </p>
            <ul className="gs-u-mb++">
              <li className="gs-u-ml++ gs-u-mb+">
                <strong>Banner Display:</strong> Your advertising banner will be
                prominently displayed on the walls of our gym for a full year.
              </li>
              <li className="gs-u-ml++ gs-u-mb+">
                <strong className="gs-u-mb+ gs-u-display-block">
                  Pricing Options:
                </strong>
                <ul>
                  <li className="gs-u-ml++ gs-u-mb+">
                    <strong>£150</strong> for providing your own banner (max
                    size 2m x 1m)
                  </li>
                  <li className="gs-u-ml++">
                    <strong>£200</strong> if you'd like the gym to provide a 2m
                    x 1m banner. We will create a mock-up of the banner for your
                    approval before printing.
                  </li>
                </ul>
              </li>
              <li className="gs-u-ml++ gs-u-mb+">
                We can also display your business cards at no extra cost.
              </li>
            </ul>

            <p className="gel-pica-bold gs-u-mb++">Additional Benefits:</p>
            <ul className="gs-u-mb++">
              <li className="gs-u-ml++ gs-u-mb+">
                Promotion on our <strong>Facebook page</strong> to help boost
                your exposure.
              </li>
              <li className="gs-u-ml++ gs-u-mb+">
                A dedicated <strong>advert on our website</strong> for even more
                visibility.
              </li>
            </ul>

            <p className="gs-u-mb+">
              This opportunity allows you to reach a dynamic and engaged
              audience. For just £200 per year, we'll help create a banner that
              aligns with your business needs and ensure it's prominently
              displayed for the entire year.
            </p>

            <p>
              If you'd like to take advantage of this opportunity, please get in
              touch with us at the gym. We look forward to working with you!
            </p>
            <div
              className="gs-u-mt++"
              style={{ maxWidth: '200px', margin: '0 auto' }}
            >
              <a
                className="button button--filled button--full button--large"
                href="mailto:thegymatmoffat@gmail.com?subject=Advertising%20Enquiry"
              >
                <i className="fa fa-envelope gs-u-mr" />
                Get in touch
              </a>
            </div>
          </div>
        }
      />
    </>
  );
};

Advertising.defaultProps = {};

Advertising.propTypes = {};

export default connect(mapStateToProps)(Advertising);
